import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import checkPermission from '../../../../../Components/Hooks/PermissionHook';
import { getFeeds } from '../../../../../slices/feeds/thunk';
import { toggleFeedConnectionLoader, toggleFeedConnectionModal } from '../../../../../slices/modals/reducer';
import { resetTableFilter } from '../../../../../slices/folder/thunk';
import { setFeedsFirstLoad, setFeedsHasMore, setFeedsLoading, setFeedsPage, setFeedsShowLoader } from '../../../../../slices/feeds/reducer';

function FeedBindBtn() {
  const dispatch = useDispatch();

  const selectStates = createSelector(state => state, state => ({
    brandPath: state.MenuData.brandPath,
    marketPath: state.MenuData.marketPath,
    currentVersion: state.Campaign.currentVersion,
    connectedFeed: state.Campaign.connectedFeed,
    dynamicVideoError: state.Campaign.dynamicVideoError
  }))
  const { brandPath, marketPath, currentVersion, connectedFeed, dynamicVideoError } = useSelector(selectStates);

  async function showFeeds() {
    dispatch(resetTableFilter());
    dispatch(toggleFeedConnectionModal());
    dispatch(toggleFeedConnectionLoader());
    dispatch(setFeedsPage(1));
    dispatch(setFeedsLoading(false));
    dispatch(setFeedsShowLoader(false));
    dispatch(setFeedsHasMore(true));
    dispatch(setFeedsFirstLoad(false));
    await dispatch(getFeeds());
    dispatch(toggleFeedConnectionLoader());
  }

  if (checkPermission((marketPath ? "markets" : "brands"), (marketPath ? marketPath : brandPath), "campaignEdit")) {
    if (connectedFeed) {
      return (
        <button
          className={'btn btn-icon btn-info'}
          onClick={showFeeds}
          disabled={dynamicVideoError ? true : false}
        >
          <i className='mdi mdi-rss'></i>
        </button>
      )
    } else if (connectedFeed === null) {
      return (
        <button
          className={'btn btn-icon btn-soft-dark'}
          onClick={showFeeds}
        >
          <i className='mdi mdi-rss'></i>
        </button>
      )
    } else {
      return (
        <button
          className='btn btn-icon w-auto px-2 btn-soft-danger'
          onClick={showFeeds}
          disabled={dynamicVideoError ? true : false}
        >
          <i className='mdi mdi-rss me-2 fs-5'></i>
          Feed Error
        </button>
      )
    }

  } else {
    return null;
  }

}

export default FeedBindBtn
